import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex flex-wrap flex-stack gap-3 mb-6" }
const _hoisted_2 = { class: "d-flex flex-wrap gap-3 w-100 w-md-auto w-lg-auto" }
const _hoisted_3 = { class: "svg-icon svg-icon-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-repeat fs-1 text-gray-800 d-none d-md-block" }, null, -1)
const _hoisted_5 = { class: "d-block d-md-none" }
const _hoisted_6 = { class: "d-flex w-100 w-md-auto w-lg-auto" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_AddRepman = _resolveComponent("AddRepman")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_input, {
          modelValue: _ctx.search,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
          type: "text",
          class: "w-100 w-md-auto w-lg-300px",
          placeholder: _ctx.t('search')
        }, {
          prefix: _withCtx(() => [
            _createElementVNode("span", _hoisted_3, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder"]),
        _createVNode(_component_el_tooltip, {
          effect: "dark",
          content: _ctx.t('update'),
          placement: "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              plain: "",
              onClick: _ctx.getListRepman,
              class: "w-100 w-md-auto w-lg-auto"
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.t('update')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["content"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.openModal,
          class: "w-100 w-md-auto w-lg-auto"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('register')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    (_ctx.filteredList.length > 0)
      ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          key: 0,
          data: _ctx.filteredList,
          border: "",
          "table-layout": 'auto'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "idrepman",
              label: "ID",
              width: "80",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "person",
              label: _ctx.t('name')
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "function_name",
              label: _ctx.t('role')
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.t('dateStart')
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.moment(row.date_start).format('DD/MM/YYYY')), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.t('dateEnd')
            }, {
              default: _withCtx(({ row }) => [
                (row.date_end)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.moment(row.date_end).format('DD/MM/YYYY')), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "created_at",
              label: _ctx.t('registered'),
              width: "180"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.moment(row.created_at).format('DD/MM/YYYY HH:mm:ss')), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.t('state'),
              width: "120",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", {
                  class: _normalizeClass(`badge badge-${row.status_class}`)
                }, _toDisplayString(row.status_name), 3)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.t('options'),
              fixed: "right"
            }, {
              default: _withCtx(({ row }) => [
                (row.mstatus == 1)
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 0,
                      effect: "dark",
                      content: _ctx.t('delete'),
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("i", {
                          class: "bi bi-trash fs-2 text-hover-danger me-4 cursor-pointer",
                          onClick: ($event: any) => (_ctx.onChangeStatus(row, _ctx.t('delete'), 0))
                        }, null, 8, _hoisted_8)
                      ]),
                      _: 2
                    }, 1032, ["content"]))
                  : _createCommentVNode("", true),
                (row.mstatus == 1)
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 1,
                      effect: "dark",
                      content: _ctx.t('archive'),
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("i", {
                          class: "bi bi-folder-symlink fs-2 text-info cursor-pointer",
                          onClick: ($event: any) => (_ctx.onChangeStatus(row, _ctx.t('archive'), 2))
                        }, null, 8, _hoisted_9)
                      ]),
                      _: 2
                    }, 1032, ["content"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _ctx.loader]
        ])
      : _withDirectives((_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          description: _ctx.t('empty')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.getListRepman
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('tryAgain')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["description"])), [
          [_directive_loading, _ctx.loader]
        ]),
    _createVNode(_component_AddRepman, {
      ref: "modalAddRepmanRef",
      idinstitution: _ctx.id,
      onOnResponse: _ctx.onResponse
    }, null, 8, ["idinstitution", "onOnResponse"])
  ], 64))
}